"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: "10",
    height: "12",
    viewBox: "0 0 10 12"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0,6.00292933 C0,5.44902676 0.455664396,5 0.995397568,5 L9.00460243,5 C9.55434533,5 10,5.43788135 10,6.00292933 L10,10.9970707 C10,11.5509732 9.5443356,12 9.00460243,12 L0.995397568,12 C0.445654671,12 0,11.5621186 0,10.9970707 L0,6.00292933 Z M2,3 L4,3 L4,5 L2,5 L2,3 Z M6,3 L8,3 L8,5 L6,5 L6,3 Z M8,3 C8,1.34314575 6.65685425,0 5,0 C3.34314575,0 2,1.34314575 2,3 L4,3 C4,2.44771525 4.44771525,2 5,2 C5.55228475,2 6,2.44771525 6,3 L8,3 Z"
  }));
};

exports["default"] = _default;